const SCOPE = {
  admin: 'admin',
  author: 'author',
  editor: 'editor',
  manage: 'manage',
  sales: 'sales',
};

module.exports = SCOPE;
